import type { FaireProductEntity } from "../../entity_types/product";

export const p_v6zxyeew52: FaireProductEntity = {
  token: "p_v6zxyeew52",
  type: "product",
  name: "Paved Horsebit Link Chain Necklace- Moissanite And Gold Dipped Sterling Silver",
  brandToken: "b_eow5j1bbc8",
  brandName: "Ellison+Young",
  imageUrl:
    "https://cdn.faire.com/fastly/d3ab696c9b91b100c9c8aa328854f1eb179a4b66d6e3f4a38c33c2fdda99cf83.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a6e76f7eb83ad9c45b2b6f05fc495598c1c8c2b323125d6bb886d9ba4190ad4.jpeg",
    "https://cdn.faire.com/fastly/4ccf1577c73508dce8766594c8d0e83b5eff3c3fe342de572501f1dac7ea0809.jpeg",
    "https://cdn.faire.com/fastly/0e5205f4254e36b9ea81f49b4bc62a5e9d2bfa70f5115aec9f58fd9bd41dc269.jpeg",
    "https://cdn.faire.com/fastly/a033f1f10dd0fe7d667141eb2e812dfef543e6fccde5174104d6c2ec040ac5ec.jpeg",
  ],
  priceDollars: 492,
  description:
    'Indulge in luxury with our Paved Horsebit Link Chain Necklace. The alternating oval and horsebit links, adorned with brilliant moissanite, radiate elegance. Each link is plated in white or yellow gold, adding a modern twist to this timeless design. Sparkle and sophistication effortlessly intertwined.\n\nMoissanite is set in sterling silver dipped in gold\n\n*Chain Length: 17"\n*Avalon clasp closure\n\nConflict-free, socially responsible moissanites.\n\n*Color: DEF, \n*Clarity: VVS\n',
  tags: [],
  msrpDollars: 1230,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:27.169Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
